import { loadOldPage } from '@/locallib/loadOld';
import type { EntryGenerator, PageLoad } from './$types';

export const load: PageLoad = async ({ url, params, fetch }) => {
	console.log('load url', url, { ...params });

	const reply = await loadOldPage(
		`index.php@option=com_content&task=view&id=${params.view_id}.html`,
		fetch
	);

	return { html: reply };
};

export const prerender = true;
export const ssr = true;

export const entries: EntryGenerator = async () => {
	return [
		{ view_id: '10011' },
		{ view_id: '10012' },
		{ view_id: '10017' },
		{ view_id: '10027' },
		{ view_id: '10030' },
		{ view_id: '10032' },
		{ view_id: '50010' },
		{ view_id: '50014' },
		{ view_id: '50037' },
		{ view_id: '50038' },
		{ view_id: '50039' },
		{ view_id: '50040' },
		{ view_id: '50041' },
		{ view_id: '50042' },
		{ view_id: '50043' },
		{ view_id: '50044' },
		{ view_id: '50045' },
		{ view_id: '50048' },
		{ view_id: '50049' },
		{ view_id: '5005' },
		{ view_id: '50050' },
		{ view_id: '50053' },
		{ view_id: '50055' },
		{ view_id: '50056' },
		{ view_id: '50057' },
		{ view_id: '5006' },
		{ view_id: '5007' },
		{ view_id: '5008' },
		{ view_id: '5009' },
		{ view_id: '5005' }

		// { path: '' },
		// { path: 'cat/1' },
		// { path: 'cat/10' }
		// { path: 'cat/11' },
		// { path: 'cat/13' },
		// { path: 'cat/15' },
		// { path: 'cat/17' },
		// { path: 'cat/18' },
		// { path: 'cat/19' },
		// { path: 'cat/2' },
		// { path: 'cat/20' },
		// { path: 'cat/21' },
		// { path: 'cat/22' },
		// { path: 'cat/23' },
		// { path: 'cat/24' },
		// { path: 'cat/25' },
		// { path: 'cat/26' },
		// { path: 'cat/27' },
		// { path: 'cat/28' },
		// { path: 'cat/29' },
		// { path: 'cat/3' },
		// { path: 'cat/30' },
		// { path: 'cat/31' },
		// { path: 'cat/32' },
		// { path: 'cat/33' },
		// { path: 'cat/34' },
		// { path: 'cat/4' },
		// { path: 'cat/5' },
		// { path: 'cat/6' },
		// { path: 'cat/7' },
		// { path: 'cat/8' },
		// { path: 'cat/9' },
		// { path: 'page/11' },
		// { path: 'page/12' },
		// { path: 'page/13' },
		// { path: 'page/14' },
		// { path: 'page/15' },
		// { path: 'page/16' },
		// { path: 'page/17' },
		// { path: 'page/18' },
		// { path: 'page/19' },
		// { path: 'page/20' },
		// { path: 'page/21' },
		// { path: 'page/22' },
		// { path: 'page/24' },
		// { path: 'page/25' },
		// { path: 'page/26' },
		// { path: 'page/27' },
		// { path: 'page/28' },
		// { path: 'page/29' },
		// { path: 'page/30' },
		// { path: 'page/31' },
		// { path: 'page/32' },
		// { path: 'view/10011' },
		// { path: 'view/10012' },
		// { path: 'view/10017' },
		// { path: 'view/10027' },
		// { path: 'view/10030' },
		// { path: 'view/10032' },
		// { path: 'view/50010' },
		// { path: 'view/50014' },
		// { path: 'view/50037' },
		// { path: 'view/50038' },
		// { path: 'view/50039' },
		// { path: 'view/50040' },
		// { path: 'view/50041' },
		// { path: 'view/50042' },
		// { path: 'view/50043' },
		// { path: 'view/50044' },
		// { path: 'view/50045' },
		// { path: 'view/50048' },
		// { path: 'view/50049' },
		// { path: 'view/5005' },
		// { path: 'view/50050' },
		// { path: 'view/50053' },
		// { path: 'view/50055' },
		// { path: 'view/50056' },
		// { path: 'view/50057' },
		// { path: 'view/5006' },
		// { path: 'view/5007' },
		// { path: 'view/5008' },
		// { path: 'view/5009' },
		// { path: 'view/1/2' },
		// { path: 'view/5005' }
		// { path: 'view/50054/6' }
	];
};
